<template>
  <div>
    <el-table :data="list" style="width: 100%" border size="mini">
      <el-table-column prop="name" label="项目名称" min-width="180" align="center">
      </el-table-column>
      <el-table-column prop="remark" label="设置" min-width="180" align="center">
        <template #default="scope">
          <subject-list v-if="scope.row.valueType == 'select'" :codes="$findCode(scope.row.option)" v-model:subjectId="scope.row.subjectId" v-model:fzhsItemId="scope.row.fzhsId"></subject-list>
          <el-radio-group v-if="scope.row.valueType == 'radio'" v-model="scope.row.value" size="mini">
            <!-- <el-radio v-for="item in scope.row.option" :label="item.name" :key="item.value"></el-radio> -->
            <el-radio v-for="item in scope.row.option" :label="item.value" :key="item.index">{{item.name}}</el-radio>
          </el-radio-group>
          <el-input v-if="scope.row.valueType == 'input'" size="mini" v-model="scope.row.value"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="remark" label="备注" min-width="180" align="center">
      </el-table-column>
      <el-table-column label="操作" min-width="180" align="center">
        <template #default="scope">
          <el-button @click="saveSetting(scope.row)" type="text" size="small">保存</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { getComSetList , setComSet } from "@/api/company";
export default {
  name:'otherSetting',
  data() {
    return {
      list:[],
    }
  },
  created() {
    this.contentStyleObj= this.$getHeight(280)
    this.init()
  },
  methods: {
    init(){
      this.getList()
    },
    getList(){
      let comId = this.$store.getters["commons/params"].editCustomerComId * 1
      if(this.$store.getters["user/comInfo"].comId * 1){
        comId = this.$store.getters["user/comInfo"].comId * 1
      }else if(this.$store.getters["commons/params"].editCustomerComId.id *1){
        comId = this.$store.getters["commons/params"].editCustomerComId.id
      }
      getComSetList({comId}).then(res=>{
        this.list = res.data.data.list
      })
    },
    saveSetting(row){
      setComSet(row).then(res=>{
        if(res.data.msg == "success"){
          this.$qzfMessage("保存成功")
        }
      })
    },
  }
}
</script>

<style>

</style>